<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <rect width="36" height="36" rx="18" fill="#485175"/>
    <path d="M4.5 18C4.5 21.5804 5.92232 25.0142 8.45406 27.5459C10.9858 30.0777 14.4196 31.5 18 31.5C21.5804 31.5 25.0142 30.0777 27.5459 27.5459C30.0777 25.0142 31.5 21.5804 31.5 18C31.5 14.4196 30.0777 10.9858 27.5459 8.45406C25.0142 5.92232 21.5804 4.5 18 4.5C14.4196 4.5 10.9858 5.92232 8.45406 8.45406C5.92232 10.9858 4.5 14.4196 4.5 18Z" stroke="white" stroke-opacity="0.2" stroke-width="1.63636" stroke-linecap="round" stroke-linejoin="round"/>
    <g transform="translate(6 10)">
        <path d="M5.96875 3.9375H7.28125M7.28125 3.9375H17.7812M7.28125 3.9375L7.28125 13.125C7.28125 13.4731 7.41957 13.8069 7.66573 14.053C7.91188 14.2992 8.24565 14.4375 8.59375 14.4375H15.1562C15.5043 14.4375 15.8381 14.2992 16.0843 14.053C16.3304 13.8069 16.4688 13.4731 16.4688 13.125V3.9375M9.25 3.9375V2.625C9.25 2.2769 9.38832 1.94306 9.63447 1.69691C9.88063 1.45075 10.2144 1.3125 10.5625 1.3125H13.1875C13.5356 1.3125 13.8694 1.45075 14.1155 1.69691C14.3617 1.94306 14.5 2.2769 14.5 2.625V3.9375M10.5625 7.21875V11.1562M13.1875 7.21875V11.1562" stroke="white" stroke-width="1.575" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    </svg>
</template>
<script>
const deleteIcon = {
    name: 'deleteIcon',
    props: {
    }
}
export default deleteIcon
export { deleteIcon }
</script>